onComplete(function() {
	// De openingstijdentabel begint op maandag; markeer de rij van vandaag zoals de oude site deed.
	var todayIndex = (new Date().getDay() + 6) % 7;
	document.querySelectorAll('.page-hours .opening_times-overview').forEach(function(table) {
		var row = table.querySelectorAll('tr')[todayIndex];
		if (row) {
			row.classList.add('is-today');
		}
	});

	// "Bekijk ook" toont de hele teamlijst; het teamlid van de huidige pagina hoort daar niet bij.
	var trimSlash = function(url) {
		return url.replace(/\/+$/, '');
	};
	var currentUrl = trimSlash(window.location.href.split(/[?#]/)[0]);
	document.querySelectorAll('.team-related .team-list').forEach(function(list) {
		list.classList.add('is-related');
		Array.prototype.forEach.call(list.children, function(item) {
			var link = item.querySelector('.team-card a[href]');
			if (link && trimSlash(link.href) === currentUrl) {
				item.classList.add('is-current');
			}
		});
	});
});
